import { Controller } from "@hotwired/stimulus"
import TableFrameNavigator from "../../utils/table_frame_navigator"
import TableQueryState from "../../utils/table_query_state"

// Connects to data-controller="insurances--quick-filters"
export default class extends Controller {
  static outlets = ["insurances--filter"]

  connect() {
    this.tableNavigator = new TableFrameNavigator({ frameId: "insurances_list", tableKey: "insurances" })
    this.#initializeQuickFilters()
  }

  disconnect() {
    this.tableNavigator?.disconnect()
  }

  applyQuickFilter(event) {
    const currentQueryParams = new URLSearchParams(window.location.search)
    let newParams = new URLSearchParams()
    const filterController = this.hasInsurancesFilterOutlet ? this.insurancesFilterOutlet : null

    if (event.target.value !== "all" && !currentQueryParams.has("quickFilter")) {
      this.element.dataset.queryParams = currentQueryParams.toString()
      filterController?.removeValuesFromFilters()
    }
    if (event.target.value !== "all") {
      newParams.set("quickFilter", event.target.value)
    }

    const currentYear = new Date().getUTCFullYear()
    const lastYear = currentYear - 1

    switch (event.target.value) {
      case "all":
        newParams = new URLSearchParams(this.element.dataset.queryParams || "")
        break
      case "transaction_this_year":
        newParams.set("transactionDateFrom", `${currentYear}-01-01`)
        newParams.set("transactionDateTo", `${currentYear}-12-31`)
        break
      case "transaction_last_year":
        newParams.set("transactionDateFrom", `${lastYear}-01-01`)
        newParams.set("transactionDateTo", `${lastYear}-12-31`)
        break
      case "health_this_year":
        newParams.set("transactionDateFrom", `${currentYear}-01-01`)
        newParams.set("transactionDateTo", `${currentYear}-12-31`)
        newParams.set("type", "health")
        break
      case "health_last_year":
        newParams.set("transactionDateFrom", `${lastYear}-01-01`)
        newParams.set("transactionDateTo", `${lastYear}-12-31`)
        newParams.set("type", "health")
        break
      case "social_this_year":
        newParams.set("transactionDateFrom", `${currentYear}-01-01`)
        newParams.set("transactionDateTo", `${currentYear}-12-31`)
        newParams.set("type", "social")
        break
      case "social_last_year":
        newParams.set("transactionDateFrom", `${lastYear}-01-01`)
        newParams.set("transactionDateTo", `${lastYear}-12-31`)
        newParams.set("type", "social")
        break
      case "health_clearance_this_year":
        newParams.set("transactionDateFrom", `${currentYear}-01-01`)
        newParams.set("transactionDateTo", `${currentYear}-12-31`)
        newParams.set("type", "health_annual_clearance")
        break
      case "health_clearance_last_year":
        newParams.set("transactionDateFrom", `${lastYear}-01-01`)
        newParams.set("transactionDateTo", `${lastYear}-12-31`)
        newParams.set("type", "health_annual_clearance")
        break
      default:
        break
    }
    this.#constructUrlAndSendRequest(newParams)
  }

  #constructUrlAndSendRequest(params) {
    this.tableNavigator.navigate(new TableQueryState(params), {
      history: "push",
      reason: "filter",
      preserveScroll: { x: true, y: false }
    })
  }

  #initializeQuickFilters() {
    const currentQueryParams = new URLSearchParams(window.location.search)
    if (currentQueryParams.has("quickFilter")) {
      const quickFilterId = `quick_filter_${currentQueryParams.get("quickFilter")}`
      const element = document.getElementById(quickFilterId)
      if (element) {
        element.checked = true
      }
    } else {
      const allElement = document.getElementById("quick_filter_all")
      if (allElement) {
        allElement.checked = true
      }
    }
  }
}
